<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
	<div style="display: flex; align-items: center;">
		<p class="modal-title">{{data.nzTitle}}</p>
	</div>
</div>

<div class="mx-4">
	@if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
		<form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
			<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
				<nz-form-item nz-col nzXs="24" nzSm="12" nzMd="8" class="px-4">
					<nz-form-label nzRequired>
						Razón de la merma
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique la razón de la merma">
						<nz-select nzShowSearch nzPlaceHolder="Indique la razón de la merma" formControlName="selectedReason">
							@for (lossReason of lossReasons; track lossReason) {
							<nz-option [nzValue]="lossReason.id" [nzLabel]="lossReason.name">
							</nz-option>
							}
						</nz-select>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" class="px-4">
					<nz-form-label [nzRequired]="true">
						Artículo
					</nz-form-label>
                    @if(data.origin === LossSourceEnum.RAW_MATERIAL ){
                        <nz-form-control nzErrorTip="Indique la materia prima mermada">
                            <nz-select nzShowSearch formControlName="rawMaterialSelected"
                                [nzPlaceHolder]="'Indique la materia prima mermada'">
                                @for (option of data.rawMaterials; track option) {
                                <nz-option
                                    [nzLabel]="option.article?.name + (option.articleBatch ? ('-' + option.articleBatch.batchNumber) : '' )"
                                    [nzValue]="option.id"></nz-option>
                                }
                            </nz-select>
                        </nz-form-control>
                    } @else if (data.origin === LossSourceEnum.FINAL_PRODUCT ){
                        <nz-form-control nzErrorTip="Indique el product final mermado">
                            <nz-select nzShowSearch formControlName="finalProductSelected"
                                [nzPlaceHolder]="'Indique el producto final mermado'">
                                @for (option of data.finalProducts; track option) {
                                <nz-option
                                    [nzLabel]="option.article?.name + (option.articleBatch ? ('-' + option.articleBatch.batchNumber) : '' )"
                                    [nzValue]="option.id"></nz-option>
                                }
                            </nz-select>
                        </nz-form-control>
                    }
				</nz-form-item>
				<nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
					<nz-form-label nzRequired>
						Cantidad
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique la cantidad de producto mermado">
						<input onfocus="select()" formControlName="quantity" nz-input type="number"
							placeholder="Indique la cantidad de producto mermado" />
					</nz-form-control>
				</nz-form-item>
				<nz-form-item nz-col nzXs="24" nzSm="12" nzMd="6" class="px-4">
					<nz-form-label nzRequired>
						Unidad de medida
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique la unidad de medida de la merma">
						<nz-select nzShowSearch formControlName="selectedMeasurementUnitId"
							nzPlaceHolder="Indique la unidad de medida de la merma">
							@for (measurement of measurementUnits; track measurement) {
							<nz-option [nzValue]="measurement.id" [nzLabel]="measurement.abbreviation">
							</nz-option>
							}
						</nz-select>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
					<nz-form-label>
						Observaciones
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique información acerca de la merma">
						<textarea formControlName="observations" nz-input rows="4"
							placeholder="Indique información acerca de la merma"></textarea>
					</nz-form-control>
				</nz-form-item>
			</div>
		</form>
	}
</div>

<div *nzModalFooter>
	<div class="flex justify-end">
		<button (click)="handleCancel()" class="button secondary-button mr-2">
			Cancelar
		</button>

		<button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
			Crear
		</button>
	</div>
</div>
